import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import UserInfo from './UserInfo'
import ColorMode from './ColorMode'
import { forceLogout } from '../services/auth/session'

const navItems = [
  { name: 'Přehledy', icon: 'bi-columns-gap', link: '/dashboard' },
  { name: 'Rezervace', icon: 'bi-calendar-week', link: '/reservations' },
  { name: 'Objednávky', icon: 'bi-collection', link: '/orders' },
  { name: 'Poptávky', icon: 'bi-box2', link: '/requests' },
  { name: 'Úschovy', icon: 'bi-safe', link: '/storages' },
  { name: 'Nastavení', icon: 'bi-gear', link: '/settings' },

  // { name: 'Public', icon: 'bi-calendar', link: '/rezervace-online' },
  { name: 'Odhlásit', icon: 'bi-box-arrow-right', link: '/login' }
]

const NavigationAdmin = ({ user, setUser }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const mobileMenuRef = useRef(null)
  const mobileToggleRef = useRef(null)
  const location = useLocation()
  const navigate = useNavigate()
  const isTechnician = Number(user?.role) === 2
  const primaryItems = navItems
    .slice(0, -1)
    .filter((item) => !(isTechnician && item.link === '/settings'))

  // fce pro odhlášení
  const handleLogout = (e) => {
    e.preventDefault()
    forceLogout({ redirect: false })
    if (typeof setUser === 'function') setUser(null)
    navigate('/login', { replace: true })
  }

  useEffect(() => {
    if (!mobileMenuOpen) return

    const handlePointerDown = (e) => {
      const target = e.target
      const clickedInMenu = mobileMenuRef.current?.contains(target)
      const clickedToggle = mobileToggleRef.current?.contains(target)
      if (!clickedInMenu && !clickedToggle) setMobileMenuOpen(false)
    }

    const handleEscape = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false)
    }

    document.addEventListener('mousedown', handlePointerDown)
    document.addEventListener('touchstart', handlePointerDown, { passive: true })
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handlePointerDown)
      document.removeEventListener('touchstart', handlePointerDown)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [mobileMenuOpen])
  
  return (
    <>
    {/* Mobile Top Bar */}
    <div className="mobile-header d-md-none">
      <div className="d-flex align-items-center gap-2">        
        <Link to="/dashboard" className="mobile-logo">
          <svg width="35" height="35" viewBox="3250 4000 14000 12000" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M8469.39 4560.02v3344.05l1836.83-1081.97 1836.83 1081.97V4560.02l-1836.83-1081.96-1836.83 1081.96zm1836.83 9195.12h1836.83v-500.87l-1836.83-1081.97-1836.83 1081.97v500.87h1836.83zm1836.83-4848v3344.05l-1836.83-1081.96-1836.83 1081.96V8907.14l1836.83-1081.96 1836.83 1081.96zM7617.87 8405.66V5061.62L5202.73 6484.23l-.03 3344.04zM7617.87 12752.78V9408.74l-2415.14 1422.61v1767.97c0 513.88 339.93 952.19 805.98 1101.32l1609.16-947.86zM6358.55 3478.06h1259.32v580.48L5202.73 5481.12v-847.24c0-635.7 520.12-1155.82 1155.82-1155.82zM12994.57 8405.66V5061.62l2415.14 1422.61.03 3344.04zM12994.57 12752.78V9408.74l2415.14 1422.61v1767.97c0 513.88-339.93 952.19-805.98 1101.32l-1609.16-947.86zM14253.89 3478.06h-1259.32v580.48l2415.14 1422.58v-847.24c0-635.7-520.12-1155.82-1155.82-1155.82z"/>
          </svg>
        </Link>
        <UserInfo user={user} /> 
      </div>
      <div className="d-flex align-items-center gap-2">
        <ColorMode className="btn btn-sm mobile-color-mode-btn" />
        <button ref={mobileToggleRef} className="mobile-toggler" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <i className="bi bi-list"></i>
        </button>        
      </div>               
    </div>

    {/* Mobile Menu Offcanvas */}
    {mobileMenuOpen && (
      <div ref={mobileMenuRef} className="mobile-menu d-md-none">
        <div className="menu-grid">
          {primaryItems.map((item, index) => (
            <Link to={item.link} key={index} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="menu-item">
              <i className={`bi ${item.icon}`}></i>
              <span>{item.name}</span>
            </Link>
          ))}
            <Link to="/login" onClick={handleLogout} className="menu-item">
              <i className="bi bi-box-arrow-right"></i>
              <span>Odhlásit</span>    
            </Link>
        </div>
      </div>
    )}

    <div className="tablet-admin-nav">
      <Link to="/dashboard" className="tablet-admin-logo">
        <svg width="34" height="34" viewBox="3250 4000 14000 12000" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M8469.39 4560.02v3344.05l1836.83-1081.97 1836.83 1081.97V4560.02l-1836.83-1081.96-1836.83 1081.96zm1836.83 9195.12h1836.83v-500.87l-1836.83-1081.97-1836.83 1081.97v500.87h1836.83zm1836.83-4848v3344.05l-1836.83-1081.96-1836.83 1081.96V8907.14l1836.83-1081.96 1836.83 1081.96zM7617.87 8405.66V5061.62L5202.73 6484.23l-.03 3344.04zM7617.87 12752.78V9408.74l-2415.14 1422.61v1767.97c0 513.88 339.93 952.19 805.98 1101.32l1609.16-947.86zM6358.55 3478.06h1259.32v580.48L5202.73 5481.12v-847.24c0-635.7 520.12-1155.82 1155.82-1155.82zM12994.57 8405.66V5061.62l2415.14 1422.61.03 3344.04zM12994.57 12752.78V9408.74l2415.14 1422.61v1767.97c0 513.88-339.93 952.19-805.98 1101.32l-1609.16-947.86zM14253.89 3478.06h-1259.32v580.48l2415.14 1422.58v-847.24c0-635.7-520.12-1155.82-1155.82-1155.82z"/>
        </svg>
      </Link>
      <div className="tablet-admin-nav-scroll">
        {primaryItems.map((item) => (
          <Link
            key={item.name}
            to={item.link}
            className={`tablet-admin-link ${location.pathname === item.link ? 'active' : ''}`}
          >
            <i className={`bi ${item.icon}`}></i>
            <span>{item.name}</span>
          </Link>
        ))}
        <button type="button" onClick={handleLogout} className="tablet-admin-link tablet-admin-logout">
          <i className="bi bi-box-arrow-right"></i>
          <span>Odhlásit</span>
        </button>
      </div>
    </div>

    {/* Desktop Sidebar */}
    <aside className="sidebar d-none d-md-block">
      {/* Sidebar header */}
      <header className="sidebar-header">
        <Link to="/dashboard" className="header-logo">
          <span className="icon">
              <svg width="45" height="45" viewBox="3250 4000 14000 12000" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M8469.39 4560.02v3344.05l1836.83-1081.97 1836.83 1081.97V4560.02l-1836.83-1081.96-1836.83 1081.96zm1836.83 9195.12h1836.83v-500.87l-1836.83-1081.97-1836.83 1081.97v500.87h1836.83zm1836.83-4848v3344.05l-1836.83-1081.96-1836.83 1081.96V8907.14l1836.83-1081.96 1836.83 1081.96zM7617.87 8405.66V5061.62L5202.73 6484.23l-.03 3344.04zM7617.87 12752.78V9408.74l-2415.14 1422.61v1767.97c0 513.88 339.93 952.19 805.98 1101.32l1609.16-947.86zM6358.55 3478.06h1259.32v580.48L5202.73 5481.12v-847.24c0-635.7 520.12-1155.82 1155.82-1155.82zM12994.57 8405.66V5061.62l2415.14 1422.61.03 3344.04zM12994.57 12752.78V9408.74l2415.14 1422.61v1767.97c0 513.88-339.93 952.19-805.98 1101.32l-1609.16-947.86zM14253.89 3478.06h-1259.32v580.48l2415.14 1422.58v-847.24c0-635.7-520.12-1155.82-1155.82-1155.82z"/>
            </svg>
          </span>
        </Link>              
      </header>
      {/* Sidebar Nav */}
      <nav className="sidebar-nav">
        {/* Primary top nav */}
        <ul className="nav-list primary-nav">          
          {primaryItems.map((item) => (
            <li
              className={`nav-item ${location.pathname === item.link ? 'active' : ''}`}
              key={item.name}
            >
            <Link to={item.link} className={`nav-link ${location.pathname === item.link ? 'active' : ''}`}>
              <span className="nav-icon"><i className={`bi ${item.icon}`}></i></span>
              <span className="nav-label">{item.name}</span>    
            </Link>
            </li>
          ))}                               
        </ul>
        {/* Secondary bottom nav */}
        <ul className="nav-list secondary-nav">
          <li>
            <Link to="/login" onClick={handleLogout} className="nav-link">
              <span className="nav-icon"><i className="bi bi-box-arrow-right"></i></span>
              <span className="nav-label">Odhlásit</span>    
            </Link>             
          </li>
        </ul>
      </nav>
    </aside>
    </>
  )
}

export default NavigationAdmin




